import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=41527546&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/app.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=41527546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41527546",
  null
  
)

export default component.exports